import {
    Directive,
    ElementRef,
    HostListener,
    Output,
    EventEmitter,
  } from '@angular/core';
  
  @Directive({
    selector: '[clickOutside]',
  })
  export class ClickOutsideDirective {
    constructor(private elementRef: ElementRef) {}
    @Output()
    public clickOutside = new EventEmitter<any>();
  
    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    console.log("onClick", targetElement);
      if (!targetElement) {
        return;
      }
      const clickedInside = this.elementRef.nativeElement.contains(targetElement);
      console.log("clickedInside", clickedInside);
      if (!clickedInside) {
        this.clickOutside.emit(targetElement.id);
      }
    }
  }
  